import { getCookie, setCookie } from '../utils/cookies'

export default function () {
  const UTM_CAMPAIGN_PARAM_NAME = 'utm_campaign'
  const UTM_CAMPAIGN_COOKIE_NAME = '_gpc_utm_campaign_param_value'
  const COOKIE_DOMAIN = request?.generalCookieDomain || '.greatpetcare.com'
  const COOKIE_EXPIRATION = 1000 * 60 * 60 * 24 * 7 // 1 week

  const vetsFirstChoiceLinksToAddTerm = Array.from(
    document.querySelectorAll('a[href*="vetsfirstchoice.com"]')
  )
  const greatPetRxLinksToAddTerm = Array.from(
    document.querySelectorAll('a[href*="greatpetrx.com"]')
  )
  const covetrusPharmacyLinksToAddTerm = Array.from(
    document.querySelectorAll('a[href*="covetruspharmacy.com"]')
  )

  const utmCampaign = getUtmCampaignFromUrl()

  if (utmCampaign) {
    setCookie(
      UTM_CAMPAIGN_COOKIE_NAME,
      utmCampaign,
      COOKIE_EXPIRATION,
      COOKIE_DOMAIN
    )
  }

  if (vetsFirstChoiceLinksToAddTerm.length > 0) {
    vetsFirstChoiceLinksToAddTerm.forEach(addNewUtmParamsToLink)
  }

  if (greatPetRxLinksToAddTerm.length > 0) {
    greatPetRxLinksToAddTerm.forEach(addNewUtmParamsToLink)
  }

  if (covetrusPharmacyLinksToAddTerm.length > 0) {
    covetrusPharmacyLinksToAddTerm.forEach(addNewUtmParamsToLink)
  }

  function addNewUtmParamsToLink(link) {
    const utmCampaignFromCookie = getCookie(UTM_CAMPAIGN_COOKIE_NAME)
    const pathName = window?.location?.pathname || ''
    const url = new URL(link.href)

    if (utmCampaignFromCookie) {
      url.searchParams.set('utm_term', utmCampaignFromCookie)
    }

    if (pathName) {
      url.searchParams.set('utm_content', pathName)
    }

    link.href = url.toString()
  }

  function getUtmCampaignFromUrl() {
    const { search } = window.location
    const params = new URLSearchParams(search)
    const utmCampaignParam = params.get(UTM_CAMPAIGN_PARAM_NAME)
    return utmCampaignParam ? utmCampaignParam : null
  }
}
